import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CookAILanding from './components/CookAI';
import { DishPage } from './components/DishPage/DishPage';
import BlogListPage from './components/Blog/BlogListPage';
import BlogDetailPage from './components/Blog/BlogDetailPage';
import AdminPanel from './components/Admin/AdminPanel';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
    return (
        <LanguageProvider>
            <Router>
                <Routes>
                    {/* Main landing */}
                    <Route path="/" element={<CookAILanding />} />
                    <Route path="/privacy" element={<CookAILanding />} />
                    <Route path="/terms" element={<CookAILanding />} />
                    {/* Dish share page */}
                    <Route path="/dish/:id" element={<DishPage />} />
                    {/* Blog */}
                    <Route path="/blog" element={<BlogListPage />} />
                    <Route path="/blog/:slug" element={<BlogDetailPage />} />
                    {/* Admin panel */}
                    <Route path="/admin" element={<AdminPanel />} />
                </Routes>
            </Router>
        </LanguageProvider>
    );
}

export default App;